module.exports = __webpack_public_path__ + "files/f216da8b1c3e67cdf057acacd63f2554.png";